import React from 'react';
import { Link } from 'react-router-dom';
import { X, ArrowRight, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { useCompare } from '../context/CompareContext';

const CompareBar = () => {
  const { compareList, removeFromCompare, clearCompare } = useCompare();

  if (compareList.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white z-50 shadow-2xl border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 py-2 sm:py-3">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-0">
          <div className="flex items-center gap-2 sm:gap-4 w-full sm:w-auto overflow-x-auto">
            <span className="font-semibold text-xs sm:text-sm whitespace-nowrap">
              Compare ({compareList.length}/4)
            </span>
            <div className="flex gap-1 sm:gap-2 overflow-x-auto">
              {compareList.map((property) => (
                <div 
                  key={property.id} 
                  className="relative group bg-gray-800 rounded-lg overflow-hidden flex items-center flex-shrink-0"
                >
                  <img 
                    src={property.image} 
                    alt={property.address}
                    className="w-10 h-8 sm:w-16 sm:h-12 object-cover"
                  />
                  <div className="px-1 sm:px-2 max-w-[60px] sm:max-w-[120px] hidden sm:block">
                    <p className="text-xs font-medium truncate">{property.address}</p>
                    <p className="text-xs text-gray-400">${(property.price / 1000).toFixed(0)}K</p>
                  </div>
                  <button
                    onClick={() => removeFromCompare(property.id)}
                    className="absolute -top-1 -right-1 bg-red-600 rounded-full p-0.5 sm:p-1 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity"
                  >
                    <X size={10} className="sm:w-3 sm:h-3" />
                  </button>
                </div>
              ))}
            </div>
          </div>
          
          <div className="flex items-center gap-2 sm:gap-3 w-full sm:w-auto justify-between sm:justify-end">
            <button
              onClick={clearCompare}
              className="text-gray-400 hover:text-white text-xs sm:text-sm flex items-center gap-1"
            >
              <Trash2 size={12} className="sm:w-3.5 sm:h-3.5" />
              <span className="hidden xs:inline">Clear</span>
            </button>
            <Link to="/compare">
              <Button 
                className="bg-red-600 hover:bg-red-700 text-white text-xs sm:text-sm px-3 sm:px-4 py-1.5 sm:py-2"
                disabled={compareList.length < 2}
              >
                Compare
                <ArrowRight size={14} className="ml-1 sm:ml-2 sm:w-4 sm:h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
